import visaLogo from "@assets/visa-logo.png";

// Fixed Visa partner asset: the wordmark and the PNG are both brand blue, so
// the chip is pinned light rather than themed. No className prop — a caller
// override could put the lockup back on a surface that hides it.
const PrimeseatLogo = () => {
  return (
    <div className="flex items-center justify-center rounded-full bg-white border border-black/10 px-10 py-1.5 shadow-md">
      <img
        src={visaLogo}
        alt="Visa"
        className="h-[0.9rem] w-auto object-contain mr-2.5"
      />
      <span className="font-montserrat font-extrabold text-primeseat-blue tracking-[0.2em] uppercase text-xs whitespace-nowrap">
        Dining Collection
      </span>
    </div>
  );
};

export default PrimeseatLogo;
